/**
 * The canonical origin.
 *
 * This site was generated by Rocket.new and shipped with the builder's own host
 * baked into the committed .env. Left alone, that value reaches robots.txt, the
 * sitemap, og:url and every canonical, pointing all of them at a domain that is
 * not ours. The live site was telling Google to fetch its sitemap from
 * drawn2secu4081.builtwithrocket.new.
 *
 * So a known-bad host is rejected outright rather than trusted.
 */
const PRODUCTION_ORIGIN = 'https://drawn2security.com';

const REJECTED_HOST = /(^|\.)builtwithrocket\.new$/i;

export const SITE_URL = (() => {
  const configured = process.env.NEXT_PUBLIC_SITE_URL?.trim();
  if (!configured) return PRODUCTION_ORIGIN;
  try {
    const url = new URL(configured);
    if (REJECTED_HOST.test(url.hostname)) return PRODUCTION_ORIGIN;
    return url.origin;
  } catch {
    return PRODUCTION_ORIGIN;
  }
})();

export const absoluteUrl = (path = '/') => new URL(path, SITE_URL).toString();

/**
 * GA only runs when the id is shaped like a real one.
 *
 * The builder commits NEXT_PUBLIC_GA_MEASUREMENT_ID=your-ga-measurement-id. A
 * plain `env || fallback` check never fires on that, because the placeholder is
 * truthy, so the site loads a tag for a property that does not exist and
 * reports nothing while appearing instrumented.
 */
export const GA_ID = (() => {
  const id = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID?.trim();
  return id && /^G-[A-Z0-9]{6,}$/.test(id) ? id : null;
})();
